import { Card } from '@etg/wings';
import { css, cx, getTextStyles } from '@eti/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const cardStyle = css`
  h2,
  h3 {
    font-size: 1.125rem;
    font-weight: 700;
    margin-bottom: 16px;
  }

  ul {
    padding-inline: 8px;

    li {
      font-size: 0.875rem;
    }
  }
`;
const ProductDrawerCard = ({
  cardTitle,
  children,
  className,
  headingLevel = 2
}) => {
  const Heading = `h${headingLevel}`;
  return /*#__PURE__*/_jsxs(Card, {
    className: cx(getTextStyles(), cardStyle, className),
    padding: 16,
    children: [/*#__PURE__*/_jsx(Heading, {
      children: cardTitle
    }), children]
  });
};
export default ProductDrawerCard;
//# sourceMappingURL=ProductDrawerCard.js.map